/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeFragment = { __typename: 'ClientEmployeeType', id: string, createdAt: string, updatedAt: string, name: string, email: string, externalId?: string | null, archivedAt?: string | null, resourceGroupCount: number, archivedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null };

export type ClientEmployeesQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  applicationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  hasFileUploads?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasFileUploadsInApplication?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  includeArchived?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ClientEmployeesQuery = { __typename: 'Query', clientEmployees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, createdAt: string, updatedAt: string, name: string, email: string, externalId?: string | null, archivedAt?: string | null, resourceGroupCount: number, archivedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ClientEmployeeTotalCountQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientEmployeeTotalCountQuery = { __typename: 'Query', clientEmployees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null };

export type ClientEmployeeQueryVariables = Types.Exact<{
  clientEmployeeId: Types.Scalars['UUID']['input'];
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientEmployeeQuery = { __typename: 'Query', clientEmployee?: { __typename: 'ClientEmployeeType', id: string, createdAt: string, updatedAt: string, name: string, email: string, externalId?: string | null, archivedAt?: string | null, resourceGroupCount: number, archivedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null } | null };

export type CreateClientEmployeeMutationVariables = Types.Exact<{
  input: Types.CreateClientEmployeeMutationInput;
}>;


export type CreateClientEmployeeMutation = { __typename: 'Mutation', createClientEmployee?: { __typename: 'CreateClientEmployeeMutation', employee?: { __typename: 'ClientEmployeeType', id: string, createdAt: string, updatedAt: string, name: string, email: string, externalId?: string | null, archivedAt?: string | null, resourceGroupCount: number, archivedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type UpdateClientEmployeeMutationVariables = Types.Exact<{
  input: Types.UpdateClientEmployeeMutationInput;
}>;


export type UpdateClientEmployeeMutation = { __typename: 'Mutation', updateClientEmployee?: { __typename: 'UpdateClientEmployeeMutation', employee?: { __typename: 'ClientEmployeeType', id: string, createdAt: string, updatedAt: string, name: string, email: string, externalId?: string | null, archivedAt?: string | null, resourceGroupCount: number, archivedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DeleteClientEmployeeMutationVariables = Types.Exact<{
  input: Types.DeleteClientEmployeeMutationInput;
}>;


export type DeleteClientEmployeeMutation = { __typename: 'Mutation', deleteClientEmployee?: { __typename: 'DeleteClientEmployeeMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ClientEmployeeFragmentDoc = new TypedDocumentString(`
    fragment ClientEmployee on ClientEmployeeType {
  id
  createdAt
  updatedAt
  name
  email
  externalId
  archivedAt
  archivedBy {
    id
    name
    email
  }
  resourceGroupCount
  sessions {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
    `, {"fragmentName":"ClientEmployee"});
export const ClientEmployeesDocument = new TypedDocumentString(`
    query ClientEmployees($clientId: UUID, $applicationId: UUID, $after: String, $before: String, $first: Int, $last: Int, $offset: Int, $name_Icontains: String, $email_Icontains: String, $orderBy: String, $hasFileUploads: Boolean, $hasFileUploadsInApplication: UUID, $includeArchived: Boolean) {
  clientEmployees(
    clientId: $clientId
    applicationId: $applicationId
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    name_Icontains: $name_Icontains
    email_Icontains: $email_Icontains
    orderBy: $orderBy
    hasFileUploads: $hasFileUploads
    hasFileUploadsInApplication: $hasFileUploadsInApplication
    includeArchived: $includeArchived
  ) {
    edges {
      node {
        ...ClientEmployee
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ClientEmployee on ClientEmployeeType {
  id
  createdAt
  updatedAt
  name
  email
  externalId
  archivedAt
  archivedBy {
    id
    name
    email
  }
  resourceGroupCount
  sessions {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);

export const useClientEmployeesQuery = <
      TData = ClientEmployeesQuery,
      TError = unknown
    >(
      variables?: ClientEmployeesQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClientEmployees'] : ['ClientEmployees', variables],
    queryFn: fetcher<ClientEmployeesQuery, ClientEmployeesQueryVariables>(ClientEmployeesDocument, variables),
    ...options
  }
    )};

useClientEmployeesQuery.getKey = (variables?: ClientEmployeesQueryVariables) => variables === undefined ? ['ClientEmployees'] : ['ClientEmployees', variables];

export const useInfiniteClientEmployeesQuery = <
      TData = InfiniteData<ClientEmployeesQuery>,
      TError = unknown
    >(
      variables: ClientEmployeesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClientEmployees.infinite'] : ['ClientEmployees.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeesQuery, ClientEmployeesQueryVariables>(ClientEmployeesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeesQuery.getKey = (variables?: ClientEmployeesQueryVariables) => variables === undefined ? ['ClientEmployees.infinite'] : ['ClientEmployees.infinite', variables];


useClientEmployeesQuery.fetcher = (variables?: ClientEmployeesQueryVariables) => fetcher<ClientEmployeesQuery, ClientEmployeesQueryVariables>(ClientEmployeesDocument, variables);

export const ClientEmployeeTotalCountDocument = new TypedDocumentString(`
    query ClientEmployeeTotalCount($clientId: UUID, $after: String, $before: String, $first: Int, $last: Int, $offset: Int, $name_Icontains: String, $email_Icontains: String, $orderBy: String) {
  clientEmployees(
    clientId: $clientId
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    name_Icontains: $name_Icontains
    email_Icontains: $email_Icontains
    orderBy: $orderBy
  ) {
    totalCount
  }
}
    `);

export const useClientEmployeeTotalCountQuery = <
      TData = ClientEmployeeTotalCountQuery,
      TError = unknown
    >(
      variables?: ClientEmployeeTotalCountQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeTotalCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeTotalCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeTotalCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClientEmployeeTotalCount'] : ['ClientEmployeeTotalCount', variables],
    queryFn: fetcher<ClientEmployeeTotalCountQuery, ClientEmployeeTotalCountQueryVariables>(ClientEmployeeTotalCountDocument, variables),
    ...options
  }
    )};

useClientEmployeeTotalCountQuery.getKey = (variables?: ClientEmployeeTotalCountQueryVariables) => variables === undefined ? ['ClientEmployeeTotalCount'] : ['ClientEmployeeTotalCount', variables];

export const useInfiniteClientEmployeeTotalCountQuery = <
      TData = InfiniteData<ClientEmployeeTotalCountQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeTotalCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeTotalCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeTotalCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeTotalCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClientEmployeeTotalCount.infinite'] : ['ClientEmployeeTotalCount.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeTotalCountQuery, ClientEmployeeTotalCountQueryVariables>(ClientEmployeeTotalCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeTotalCountQuery.getKey = (variables?: ClientEmployeeTotalCountQueryVariables) => variables === undefined ? ['ClientEmployeeTotalCount.infinite'] : ['ClientEmployeeTotalCount.infinite', variables];


useClientEmployeeTotalCountQuery.fetcher = (variables?: ClientEmployeeTotalCountQueryVariables) => fetcher<ClientEmployeeTotalCountQuery, ClientEmployeeTotalCountQueryVariables>(ClientEmployeeTotalCountDocument, variables);

export const ClientEmployeeDocument = new TypedDocumentString(`
    query ClientEmployee($clientEmployeeId: UUID!, $clientId: UUID!) {
  clientEmployee(id: $clientEmployeeId, clientId: $clientId) {
    ...ClientEmployee
  }
}
    fragment ClientEmployee on ClientEmployeeType {
  id
  createdAt
  updatedAt
  name
  email
  externalId
  archivedAt
  archivedBy {
    id
    name
    email
  }
  resourceGroupCount
  sessions {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}`);

export const useClientEmployeeQuery = <
      TData = ClientEmployeeQuery,
      TError = unknown
    >(
      variables: ClientEmployeeQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeQuery, TError, TData>(
      {
    queryKey: ['ClientEmployee', variables],
    queryFn: fetcher<ClientEmployeeQuery, ClientEmployeeQueryVariables>(ClientEmployeeDocument, variables),
    ...options
  }
    )};

useClientEmployeeQuery.getKey = (variables: ClientEmployeeQueryVariables) => ['ClientEmployee', variables];

export const useInfiniteClientEmployeeQuery = <
      TData = InfiniteData<ClientEmployeeQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientEmployee.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeQuery, ClientEmployeeQueryVariables>(ClientEmployeeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeQuery.getKey = (variables: ClientEmployeeQueryVariables) => ['ClientEmployee.infinite', variables];


useClientEmployeeQuery.fetcher = (variables: ClientEmployeeQueryVariables) => fetcher<ClientEmployeeQuery, ClientEmployeeQueryVariables>(ClientEmployeeDocument, variables);

export const CreateClientEmployeeDocument = new TypedDocumentString(`
    mutation CreateClientEmployee($input: CreateClientEmployeeMutationInput!) {
  createClientEmployee(input: $input) {
    employee {
      ...ClientEmployee
    }
    errors {
      ...Error
    }
  }
}
    fragment ClientEmployee on ClientEmployeeType {
  id
  createdAt
  updatedAt
  name
  email
  externalId
  archivedAt
  archivedBy {
    id
    name
    email
  }
  resourceGroupCount
  sessions {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
fragment Error on ErrorType {
  field
  message
}`);

export const useCreateClientEmployeeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientEmployeeMutation, TError, CreateClientEmployeeMutationVariables, TContext>) => {
    
    return useMutation<CreateClientEmployeeMutation, TError, CreateClientEmployeeMutationVariables, TContext>(
      {
    mutationKey: ['CreateClientEmployee'],
    mutationFn: (variables?: CreateClientEmployeeMutationVariables) => fetcher<CreateClientEmployeeMutation, CreateClientEmployeeMutationVariables>(CreateClientEmployeeDocument, variables)(),
    ...options
  }
    )};


useCreateClientEmployeeMutation.fetcher = (variables: CreateClientEmployeeMutationVariables) => fetcher<CreateClientEmployeeMutation, CreateClientEmployeeMutationVariables>(CreateClientEmployeeDocument, variables);

export const UpdateClientEmployeeDocument = new TypedDocumentString(`
    mutation UpdateClientEmployee($input: UpdateClientEmployeeMutationInput!) {
  updateClientEmployee(input: $input) {
    employee {
      ...ClientEmployee
    }
    errors {
      ...Error
    }
  }
}
    fragment ClientEmployee on ClientEmployeeType {
  id
  createdAt
  updatedAt
  name
  email
  externalId
  archivedAt
  archivedBy {
    id
    name
    email
  }
  resourceGroupCount
  sessions {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
fragment Error on ErrorType {
  field
  message
}`);

export const useUpdateClientEmployeeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientEmployeeMutation, TError, UpdateClientEmployeeMutationVariables, TContext>) => {
    
    return useMutation<UpdateClientEmployeeMutation, TError, UpdateClientEmployeeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateClientEmployee'],
    mutationFn: (variables?: UpdateClientEmployeeMutationVariables) => fetcher<UpdateClientEmployeeMutation, UpdateClientEmployeeMutationVariables>(UpdateClientEmployeeDocument, variables)(),
    ...options
  }
    )};


useUpdateClientEmployeeMutation.fetcher = (variables: UpdateClientEmployeeMutationVariables) => fetcher<UpdateClientEmployeeMutation, UpdateClientEmployeeMutationVariables>(UpdateClientEmployeeDocument, variables);

export const DeleteClientEmployeeDocument = new TypedDocumentString(`
    mutation DeleteClientEmployee($input: DeleteClientEmployeeMutationInput!) {
  deleteClientEmployee(input: $input) {
    success
    errors {
      ...Error
    }
  }
}
    fragment Error on ErrorType {
  field
  message
}`);

export const useDeleteClientEmployeeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClientEmployeeMutation, TError, DeleteClientEmployeeMutationVariables, TContext>) => {
    
    return useMutation<DeleteClientEmployeeMutation, TError, DeleteClientEmployeeMutationVariables, TContext>(
      {
    mutationKey: ['DeleteClientEmployee'],
    mutationFn: (variables?: DeleteClientEmployeeMutationVariables) => fetcher<DeleteClientEmployeeMutation, DeleteClientEmployeeMutationVariables>(DeleteClientEmployeeDocument, variables)(),
    ...options
  }
    )};


useDeleteClientEmployeeMutation.fetcher = (variables: DeleteClientEmployeeMutationVariables) => fetcher<DeleteClientEmployeeMutation, DeleteClientEmployeeMutationVariables>(DeleteClientEmployeeDocument, variables);
